module.exports = function() {
  return new Worker("/" + "babel-transpiler.16d38a4c.worker.js");
};